export default [
  {
    path: '/:locale([en]*)?',
    name: 'Main',
    component: () => import('@/views/main/Index'),
    meta: {
      sitemap: {
        loc: '/'
      }
    }
  }
]
